"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    height: 142px;\n    width: 100%;\n    border-radius: 22px;\n    box-shadow: 0 1px 2px 0 rgba(136, 152, 170, 0.5);\n    border: solid 2px ", ";\n    background-color: ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledContent = _styledComponents["default"].span(_templateObject(), _colors.COLOR_GRAY_2, _colors.COLOR_WHITE);

var _default = StyledContent;
exports["default"] = _default;